import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d17b6c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-error",
  role: "alert"
}
const _hoisted_2 = { class: "alert-body" }
const _hoisted_3 = { class: "alert-heading" }
const _hoisted_4 = { class: "alert-text" }
const _hoisted_5 = ["data-cy"]
const _hoisted_6 = { class: "h2" }
const _hoisted_7 = { class: "form-group mt-6" }
const _hoisted_8 = {
  class: "form-label",
  for: "name"
}
const _hoisted_9 = ["data-error", "disabled", "pattern"]
const _hoisted_10 = {
  class: "form-group mt-7",
  id: "purpose-radio-buttons"
}
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = { class: "ml-2" }
const _hoisted_13 = {
  id: "purpose-field-hint",
  class: "form-hint"
}
const _hoisted_14 = { class: "nobullet-list" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["textContent"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  id: "form-label-purpose-second",
  for: "purpose-second"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  id: "form-label-purpose-third",
  for: "purpose-third"
}
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  id: "form-label-purpose-fourth",
  for: "purpose-fourth"
}
const _hoisted_23 = { class: "form-label" }
const _hoisted_24 = {
  id: "start-date-field-hint",
  class: "form-hint"
}
const _hoisted_25 = { class: "date-group mt-3" }
const _hoisted_26 = { class: "form-group form-group-day" }
const _hoisted_27 = ["aria-label"]
const _hoisted_28 = ["data-error", "disabled", "pattern"]
const _hoisted_29 = { class: "form-group form-group-month extra-space" }
const _hoisted_30 = ["aria-label"]
const _hoisted_31 = ["data-error", "disabled", "pattern"]
const _hoisted_32 = { class: "form-group form-group-year" }
const _hoisted_33 = ["aria-label"]
const _hoisted_34 = ["data-error", "disabled", "pattern"]
const _hoisted_35 = {
  key: 0,
  "aria-atomic": "true",
  class: "alert alert-warning",
  role: "alert",
  style: {"max-width":"49rem"}
}
const _hoisted_36 = { class: "alert-body" }
const _hoisted_37 = { class: "alert-text" }
const _hoisted_38 = { class: "form-label" }
const _hoisted_39 = {
  id: "end-date-field-hint",
  class: "form-hint"
}
const _hoisted_40 = { class: "date-group mt-3" }
const _hoisted_41 = { class: "form-group form-group-day" }
const _hoisted_42 = {
  class: "form-label",
  for: "end-date-day"
}
const _hoisted_43 = ["data-error", "disabled", "pattern"]
const _hoisted_44 = { class: "form-group form-group-month extra-space" }
const _hoisted_45 = {
  class: "form-label",
  for: "end-date-month"
}
const _hoisted_46 = ["data-error", "disabled", "pattern"]
const _hoisted_47 = { class: "form-group form-group-year" }
const _hoisted_48 = {
  class: "form-label",
  for: "end-date-year"
}
const _hoisted_49 = ["data-error", "disabled", "pattern"]
const _hoisted_50 = {
  key: 1,
  "aria-atomic": "true",
  class: "alert alert-info",
  role: "alert",
  style: {"max-width":"49rem"}
}
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = {
  key: 2,
  class: "form-group mt-9",
  "data-cy-name": "EmissionsfactorDropdown"
}
const _hoisted_53 = {
  class: "form-label",
  for: "input-area",
  id: "purpose-emf-update-dropdown"
}
const _hoisted_54 = ["value"]
const _hoisted_55 = {
  key: 3,
  "aria-atomic": "true",
  class: "alert alert-warning",
  role: "alert",
  style: {"max-width":"49rem"}
}
const _hoisted_56 = { style: {"display":"flex"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg-warning",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#report-problem" })
], -1))
const _hoisted_58 = {
  key: 4,
  "aria-atomic": "true",
  class: "alert alert-info",
  role: "alert",
  style: {"max-width":"49rem"}
}
const _hoisted_59 = { class: "form-group mt-9" }
const _hoisted_60 = {
  class: "form-label",
  for: "input-area"
}
const _hoisted_61 = { class: "weight-normal ml-2" }
const _hoisted_62 = ["data-error", "disabled"]
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_65 = { class: "modal-content" }
const _hoisted_66 = { class: "modal-header" }
const _hoisted_67 = { class: "modal-title" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "modal-body" }
const _hoisted_71 = { class: "modal-footer" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1))
const _hoisted_73 = {
  "aria-hidden": "false",
  class: "fds-modal"
}
const _hoisted_74 = { class: "modal-content" }
const _hoisted_75 = { class: "modal-header" }
const _hoisted_76 = { class: "modal-title" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "icon-svg",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#close" })
], -1))
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "modal-body" }
const _hoisted_80 = { class: "modal-footer" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "modal-backdrop",
  class: "modal-backdrop"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.formValidation.formErrors.size)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, [
              _createVNode(_component_SimpleText, { "text-key": "sharedContent.formErrorTitle" })
            ]),
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formValidation.formErrors, ([key, value]) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: key,
                  "data-cy": 'error_' + key
                }, _toDisplayString(value), 9, _hoisted_5))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("h1", _hoisted_6, [
      _createVNode(_component_SimpleText, { "text-key": "purpose.title" })
    ]),
    (_ctx.calculation.calculationPurpose)
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          id: "purpose",
          onChange: _cache[18] || (_cache[18] = ($event: any) => {
      _ctx.clearDateErrors($event);
      _ctx.formValidation.clearValidField($event);
    }),
          onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
          onInvalidCapture: _cache[20] || (_cache[20] = _withModifiers(($event: any) => {
      _ctx.formValidation.handleFormValidity($event, true);
      _ctx.validateDates();
    }, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.text.calculation-name" })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "name",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.calculation.calculationPurpose.name) = $event)),
              "data-error": this.nameOfCalculationError,
              disabled: _ctx.isReadOnly,
              class: "form-input",
              maxlength: "40",
              name: "name",
              pattern: _ctx.findRegexPattern('regex.validation.calculation-name'),
              required: "",
              type: "text"
            }, null, 8, _hoisted_9), [
              [_vModelText, _ctx.calculation.calculationPurpose.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("legend", _hoisted_11, [
                _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.text.about-calculation" }),
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_Tooltip, {
                    text: _ctx.getContentfulString('calculation.masterdata.text.purpose.tooltip')
                  }, null, 8, ["text"])
                ])
              ]),
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_SimpleText, { "text-key": "purpose.purposeHint" })
              ]),
              _createElementVNode("ul", _hoisted_14, [
                _createElementVNode("li", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "purpose-first",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.calculation.calculationPurpose.purpose) = $event)),
                    disabled: _ctx.isPrivateUser || _ctx.isReadOnly,
                    class: "form-radio radio-large",
                    name: "purpose",
                    type: "radio",
                    value: "realClimateFootprint"
                  }, null, 8, _hoisted_15), [
                    [_vModelRadio, _ctx.calculation.calculationPurpose.purpose]
                  ]),
                  _createElementVNode("label", {
                    id: "form-label-purpose-first",
                    for: "purpose-first",
                    textContent: _toDisplayString(this.purposeOption1)
                  }, null, 8, _hoisted_16)
                ]),
                _createElementVNode("li", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "purpose-second",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.calculation.calculationPurpose.purpose) = $event)),
                    disabled: _ctx.isPrivateUser || _ctx.isReadOnly,
                    class: "form-radio radio-large",
                    name: "purpose",
                    type: "radio",
                    value: "CO2reducingMeasures"
                  }, null, 8, _hoisted_17), [
                    [_vModelRadio, _ctx.calculation.calculationPurpose.purpose]
                  ]),
                  _createElementVNode("label", _hoisted_18, _toDisplayString(this.purposeOption2), 1)
                ]),
                _createElementVNode("li", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "purpose-third",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.calculation.calculationPurpose.purpose) = $event)),
                    disabled: _ctx.isPrivateUser || _ctx.isReadOnly,
                    class: "form-radio radio-large",
                    name: "purpose",
                    type: "radio",
                    value: "forecast"
                  }, null, 8, _hoisted_19), [
                    [_vModelRadio, _ctx.calculation.calculationPurpose.purpose]
                  ]),
                  _createElementVNode("label", _hoisted_20, _toDisplayString(this.purposeOption3), 1)
                ]),
                _createElementVNode("li", null, [
                  _withDirectives(_createElementVNode("input", {
                    id: "purpose-fourth",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.calculation.calculationPurpose.purpose) = $event)),
                    disabled: _ctx.isReadOnly,
                    class: "form-radio radio-large",
                    name: "purpose",
                    type: "radio",
                    value: "studyOrOther"
                  }, null, 8, _hoisted_21), [
                    [_vModelRadio, _ctx.calculation.calculationPurpose.purpose]
                  ]),
                  _createElementVNode("label", _hoisted_22, _toDisplayString(this.purposeOption4), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([{ 'form-error': _ctx.showStartDateError }, "form-group mt-7"])
          }, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("legend", _hoisted_23, [
                _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.text.start-date" })
              ]),
              _createElementVNode("span", _hoisted_24, [
                _createVNode(_component_SimpleText, { "text-key": "purpose.startDateHint" })
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", {
                    "aria-label": this.day,
                    class: "form-label",
                    for: "start-date-day"
                  }, [
                    _createVNode(_component_SimpleText, { "text-key": "purpose.day" })
                  ], 8, _hoisted_27),
                  _withDirectives(_createElementVNode("input", {
                    id: "start-date-day",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.startDate.day) = $event)),
                    "data-error": this.startDayError,
                    disabled: _ctx.isReadOnly,
                    "aria-placeholder": "dd",
                    class: "form-input",
                    maxlength: "2",
                    pattern: _ctx.findRegexPattern('regex.validation.date.day-of-month'),
                    placeholder: "dd",
                    required: "",
                    type: "tel",
                    inputmode: "numeric",
                    autocomplete: "off"
                  }, null, 8, _hoisted_28), [
                    [_vModelText, _ctx.startDate.day]
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", {
                    "aria-label": this.month,
                    class: "form-label",
                    for: "start-date-month"
                  }, [
                    _createVNode(_component_SimpleText, { "text-key": "purpose.month" })
                  ], 8, _hoisted_30),
                  _withDirectives(_createElementVNode("input", {
                    id: "start-date-month",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startDate.month) = $event)),
                    "data-error": this.startMonthError,
                    disabled: _ctx.isReadOnly,
                    "aria-placeholder": "mm",
                    class: "form-input js-calendar-month-input",
                    maxlength: "2",
                    pattern: _ctx.findRegexPattern('regex.validation.date.month-of-year'),
                    placeholder: "mm",
                    required: "",
                    type: "tel",
                    inputmode: "numeric",
                    autocomplete: "off"
                  }, null, 8, _hoisted_31), [
                    [_vModelText, _ctx.startDate.month]
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("label", {
                    "aria-label": this.year,
                    class: "form-label",
                    for: "start-date-year"
                  }, [
                    _createVNode(_component_SimpleText, { "text-key": "purpose.year" })
                  ], 8, _hoisted_33),
                  _withDirectives(_createElementVNode("input", {
                    id: "start-date-year",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.startDate.year) = $event)),
                    "data-error": this.startYearAfter2015error,
                    disabled: _ctx.isReadOnly,
                    "aria-placeholder": "yyyy",
                    class: "form-input js-calendar-year-input",
                    maxlength: "4",
                    pattern: _ctx.findRegexPattern('regex.validation.date.year'),
                    placeholder: "yyyy",
                    required: "",
                    type: "tel",
                    inputmode: "numeric",
                    autocomplete: "off",
                    onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.checkYear && _ctx.checkYear(...args))),
                    onFocusout: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isDefferedAccounts()))
                  }, null, 40, _hoisted_34), [
                    [_vModelText, _ctx.startDate.year]
                  ])
                ])
              ])
            ])
          ], 2),
          (_ctx.startDate.year.length === 4 && _ctx.illegalYear(_ctx.startDate.year))
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("p", _hoisted_37, [
                    _createVNode(_component_SimpleText, { "text-key": "purpose.noEmissioncoefficientsWarning" }),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.yearToUse), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass([{ 'form-error': _ctx.showEndDateError }, "form-group mt-7"])
          }, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("legend", _hoisted_38, [
                _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.text.end-date" })
              ]),
              _createElementVNode("span", _hoisted_39, [
                _createVNode(_component_SimpleText, { "text-key": "purpose.endDateHint" })
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", _hoisted_42, [
                    _createVNode(_component_SimpleText, { "text-key": "purpose.day" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "end-date-day",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.endDate.day) = $event)),
                    "data-error": this.endDayError,
                    disabled: _ctx.isReadOnly,
                    "aria-placeholder": "dd",
                    class: "form-input",
                    maxlength: "2",
                    pattern: _ctx.findRegexPattern('regex.validation.date.day-of-month'),
                    placeholder: "dd",
                    required: "",
                    type: "tel",
                    inputmode: "numeric",
                    autocomplete: "off"
                  }, null, 8, _hoisted_43), [
                    [_vModelText, _ctx.endDate.day]
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, [
                    _createVNode(_component_SimpleText, { "text-key": "purpose.month" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "end-date-month",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.endDate.month) = $event)),
                    "data-error": this.endMonthError,
                    disabled: _ctx.isReadOnly,
                    "aria-placeholder": "mm",
                    class: "form-input js-calendar-month-input",
                    maxlength: "2",
                    pattern: _ctx.findRegexPattern('regex.validation.date.month-of-year'),
                    placeholder: "mm",
                    required: "",
                    type: "tel",
                    inputmode: "numeric",
                    autocomplete: "off"
                  }, null, 8, _hoisted_46), [
                    [_vModelText, _ctx.endDate.month]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, [
                    _createVNode(_component_SimpleText, { "text-key": "purpose.year" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: "end-date-year",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.endDate.year) = $event)),
                    "data-error": this.endYearAfter2015error,
                    disabled: _ctx.isReadOnly,
                    "aria-placeholder": "yyyy",
                    class: "form-input js-calendar-year-input",
                    maxlength: "4",
                    pattern: _ctx.findRegexPattern('regex.validation.date.year'),
                    placeholder: "yyyy",
                    required: "",
                    type: "tel",
                    inputmode: "numeric",
                    autocomplete: "off",
                    onFocusout: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isDefferedAccounts()))
                  }, null, 40, _hoisted_49), [
                    [_vModelText, _ctx.endDate.year]
                  ])
                ])
              ])
            ])
          ], 2),
          (_ctx.displayPeriodInfoBanner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_SimpleText, { textKey: 'purpose.period-extends-multiple-years.info.header' }, null, 8, ["textKey"])
                  ])
                ]),
                _createElementVNode("p", { innerHTML: _ctx.multipleYearPeriodInfoText }, null, 8, _hoisted_51)
              ]))
            : _createCommentVNode("", true),
          (this.startDate.getDate.year() && this.endDate.getDate.year())
            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                _createElementVNode("label", _hoisted_53, [
                  _createVNode(_component_SimpleText, { textKey: 'purpose.emf.update.dropdown.label' }, null, 8, ["textKey"])
                ]),
                (_ctx.sortedVersions?.length > 1)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      id: "emf-year",
                      "aria-labelledby": "purpose-emf-update-dropdown",
                      class: "form-select",
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.emissionFactorYear) = $event)),
                      name: "versions",
                      onFocusout: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.isDefferedAccounts && _ctx.isDefferedAccounts(...args)))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...this.versions?.versions].sort((a, b) => b.year - a.year), (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.year,
                          value: item.year
                        }, _toDisplayString(item.year), 9, _hoisted_54))
                      }), 128))
                    ], 544)), [
                      [_vModelSelect, _ctx.emissionFactorYear]
                    ])
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isNewECVersion)
            ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                _createElementVNode("p", _hoisted_56, [
                  _hoisted_57,
                  _createElementVNode("strong", null, [
                    _createVNode(_component_SimpleText, { textKey: 'purpose.emf.update.warning.text' }, null, 8, ["textKey"])
                  ])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_SimpleText, { textKey: 'purpose.emf.update.warning.text2' }, null, 8, ["textKey"])
                ]),
                _createElementVNode("button", {
                  class: "button button-secondary",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.updateVersionConfirm(_ctx.calculation)))
                }, [
                  _createVNode(_component_SimpleText, { textKey: 'purpose.emf.update.button' }, null, 8, ["textKey"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showNewECYearInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_SimpleText, { textKey: 'purpose.emf.update.warning.year.text' }, null, 8, ["textKey"])
                  ])
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.getNewECYearWarningText), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("label", _hoisted_60, [
              _createVNode(_component_SimpleText, { "text-key": "calculation.masterdata.text.calculation-note" }),
              _createElementVNode("span", _hoisted_61, [
                _createVNode(_component_SimpleText, { "text-key": "sharedContent.optionalLabel" })
              ])
            ]),
            _withDirectives(_createElementVNode("textarea", {
              id: "input-area",
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.calculation.calculationPurpose.comment) = $event)),
              "data-error": this.purposeDescriptionError,
              disabled: _ctx.isReadOnly,
              class: "form-input",
              maxlength: "500",
              minlength: "2",
              name: "input-area",
              placeholder: "",
              rows: "5"
            }, null, 8, _hoisted_62), [
              [_vModelText, _ctx.calculation.calculationPurpose.comment]
            ])
          ]),
          _createElementVNode("button", {
            id: "submit-button",
            disabled: _ctx.isReadOnly,
            class: "button button-primary mt-705",
            type: "submit"
          }, [
            _createVNode(_component_SimpleText, { "text-key": "sharedContent.next" })
          ], 8, _hoisted_63)
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.openVersionDialog)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("h2", _hoisted_67, [
                  _createVNode(_component_SimpleText, { "text-key": "purpose.emf.update.dialog.title" })
                ]),
                _createElementVNode("button", {
                  "aria-label": "Luk",
                  class: "modal-close button button-unstyled",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.resetVersion()))
                }, _hoisted_69)
              ]),
              _createElementVNode("div", _hoisted_70, [
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_directive_dompurify_html, _ctx.updateVersionText(_ctx.calculation)]
                ])
              ]),
              _createElementVNode("div", _hoisted_71, [
                _createElementVNode("button", {
                  class: "button button-primary",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateVersionSubmit()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "purpose.emf.update.dialog.button.ok" })
                ]),
                _createElementVNode("button", {
                  class: "button button-secondary",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.resetVersion()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "purpose.emf.update.dialog.button.cancel" })
                ])
              ])
            ])
          ]),
          _hoisted_72
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.openYearDialog)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("h2", _hoisted_76, [
                  _createVNode(_component_SimpleText, { "text-key": "purpose.emf.update.dialog.year.title" })
                ]),
                _createElementVNode("button", {
                  "aria-label": "Luk",
                  class: "modal-close button button-unstyled",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.resetYear()))
                }, _hoisted_78)
              ]),
              _createElementVNode("div", _hoisted_79, [
                _withDirectives(_createElementVNode("p", null, null, 512), [
                  [_directive_dompurify_html, _ctx.updateYearText(_ctx.calculation)]
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("button", {
                  class: "button button-primary",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.updateYearSubmit()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "purpose.emf.update.dialog.button.ok" })
                ]),
                _createElementVNode("button", {
                  class: "button button-secondary",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.resetYear()))
                }, [
                  _createVNode(_component_SimpleText, { "text-key": "purpose.emf.update.dialog.button.cancel" })
                ])
              ])
            ])
          ]),
          _hoisted_81
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}